import { render, staticRenderFns } from "./BuffetHomePage.vue?vue&type=template&id=631e29fe"
import script from "./BuffetHomePage.vue?vue&type=script&lang=ts"
export * from "./BuffetHomePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports